import _Promise from 'babel-runtime/core-js/promise';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import TableList from '@/components/TableList/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import searchMixin from '@/mixin/search';
import SearchBar from '@/components/SearchV3/index.vue';
import { fetchActivityList } from '@/api/website/blog';
import { v2Host } from '@/config/host';
import { downloadWithNewWindow } from '@/common/download.js';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { statusOptions } from '@/common/permission';
import { format } from 'date-fns';
import qs from 'qs';

export default {
  components: {
    Pagination: Pagination,
    TableList: TableList,
    SearchBar: SearchBar
  },
  mixins: [searchMixin],
  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 15,
        time: []
      },
      pagination: {
        total: 0
      },
      listLoading: true,
      list: [],
      statusOptions: statusOptions,
      advertiserOptions: [],
      timeZoneList: [],
      countryList: [],
      formItemList: [{
        type: 'date-picker',
        subtype: 'daterange',
        prop: 'time',
        class: 'date-picker',
        params: {
          clearable: true,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd',
          startPlaceholder: '开始日期',
          endPlaceholder: '结束日期'
        }
      }]
    };
  },

  watch: {
    $route: function $route(to, from) {
      this.getList();
    }
  },
  computed: {
    tableColumnConfig: function tableColumnConfig() {
      var _this = this;

      return [{
        label: '日期',
        prop: 'created_time',
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            return format(row.created_time * 1000, 'YYYY-MM-DD');
          }
        }
      }, {
        label: 'campaign name',
        prop: 'campaign_name'
      }, {
        label: '广告主名称',
        prop: 'adv_name'
      }, {
        label: '广告主id',
        prop: 'adv_id',
        params: {
          innerText: function innerText(_ref2) {
            var row = _ref2.row;

            return row.adv_id === 0 ? '-' : row.adv_id;
          }
        }
      }, {
        label: '时区',
        prop: 'timezone'
      }, {
        label: '国家',
        prop: 'region'
      }, {
        label: '合作主体',
        prop: 'cooperation'
      }, {
        label: '联系方式',
        prop: 'contact'
      }, {
        label: '广告主邮箱',
        prop: 'adv_email'
      }, {
        label: 'BD',
        prop: 'bd'
      }, {
        label: 'BD_AM',
        prop: 'bd_am'
      }, {
        label: '是否MWS客户',
        prop: 'is_mws_user',
        params: {
          innerText: function innerText(_ref3) {
            var row = _ref3.row;

            return Number(row.is_mws_user) === 1 ? 'MWS客户' : '非MWS客户';
          }
        }
      }, {
        label: 'PT授权状态',
        prop: 'grant_status',
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            return _this.statusOptions[row.grant_status] || '';
          }
        }
      }, {
        label: '联系Email',
        prop: 'email'
      }, {
        label: '联系人姓名',
        prop: 'name'
      }, {
        label: '备注',
        prop: 'remark'
      }];
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.getDependencyData();

            case 2:
              _context.next = 4;
              return _this2.getList();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: {
    handleExport: function handleExport() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var params;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  params = {
                    start_time: _this3.query.time ? _this3.query.time[0] : '',
                    end_time: _this3.query.time ? _this3.query.time[1] : ''
                  };

                  delete params.time;

                  downloadWithNewWindow(v2Host + '/website/activity/export?' + qs.stringify(params));
                } catch (error) {
                  console.log(error);
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getList: function getList() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var postData, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                postData = _extends({}, _this4.query, {
                  start_time: _this4.query.time ? _this4.query.time[0] : '',
                  end_time: _this4.query.time ? _this4.query.time[1] : ''
                });

                delete postData.time;

                _context3.prev = 2;

                _this4.listLoading = true;
                _context3.next = 6;
                return fetchActivityList(postData);

              case 6:
                res = _context3.sent;


                _this4.list = (_.get(res, 'data.data.list') || []).map(function (advertiser) {
                  return _this4.cookAdvertiser(advertiser);
                });

                _this4.pagination.total = _.get(res, 'data.data.total') || 0;

                _this4.listLoading = false;
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](2);

                _this4.listLoading = false;

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[2, 12]]);
      }))();
    },
    getDependencyData: function getDependencyData() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _ref5, _ref6, _ref6$, advertiserOptions, _ref6$2, countryList, _ref6$3, timeZoneList;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _Promise.all([_this5.$store.dispatch('advertiser/getOptions'), _this5.$store.dispatch('config/getCountryList'), _this5.$store.dispatch('config/getTimeZoneList')]);

              case 2:
                _ref5 = _context4.sent;
                _ref6 = _slicedToArray(_ref5, 3);
                _ref6$ = _ref6[0];
                advertiserOptions = _ref6$ === undefined ? {} : _ref6$;
                _ref6$2 = _ref6[1];
                countryList = _ref6$2 === undefined ? [] : _ref6$2;
                _ref6$3 = _ref6[2];
                timeZoneList = _ref6$3 === undefined ? [] : _ref6$3;

                _this5.advertiserOptions = advertiserOptions;
                _this5.countryList = countryList;
                _this5.timeZoneList = timeZoneList;

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    formatTimeZone: function formatTimeZone(_ref7) {
      var timezone = _ref7.timezone;

      if (timezone) {
        var item = this.timeZoneList.find(function (item) {
          return Number(item.value) === Number(timezone);
        });

        return item ? item.label.split('(')[0] : '-';
      }
      return '-';
    },
    cookAdvertiser: function cookAdvertiser(advertiser) {
      var temp = _extends({}, advertiser, {
        timezone: this.formatTimeZone(advertiser) || '-',
        cooperation: useValueExchangeLabel(advertiser.cooperation, this.advertiserOptions.adv_cooperation_entity) || '-'
      });
      return temp;
    }
  }
};